import { render, staticRenderFns } from "./TaskReviewList.vue?vue&type=template&id=bf9c021c&"
import script from "./TaskReviewList.vue?vue&type=script&lang=js&"
export * from "./TaskReviewList.vue?vue&type=script&lang=js&"
import style0 from "./TaskReviewList.vue?vue&type=style&index=0&id=bf9c021c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports